import React, { useEffect, useState } from "react";
import FilterDayAndMonth from "../FilterDayAndMonth";
import HeaderNomResto from "../HeaderNomResto";
import Layout from "../layouts/Layout";
import CommandEmployes from "./CommandEmployes";
import ListeVendeuse from "../ListeVendeuse";
import CommandPlats from "./CommandPlats";
import ListeEntreprise from "../ListeEntreprise";
import moment from "moment";
import { DecodeToken } from "../../DecodeToken";
import { Navigate } from "react-router-dom";
import CommandEntreprises from "./CommandEntreprises";
import {
  exportDataCommandeFromApi,
  rechercherentrepriseayantcommander,
  exportDataProcessusCommandesFromApi,
} from "../../services/commandes/CommandeRequest";
import ModeRestauration from "../ListeModeRestauration";
import {
  rechercherRestaurants,
  rechercherRestaurantsAutorise,
  rechercherRestaurantsEnfant,
  recherchertouslesRestaurants,
} from "../../services/restaurants/RestaurantRequest";
import { Autocomplete, TextField } from "@mui/material";
import { Oval } from "react-loader-spinner";
import DatePicker, { registerLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { recherchervendeuseautorises } from "../../services/vendeuses/VendeuseRequest";
import { rechercherentreprises, recherchersiteparentreprise, rechercherSites } from "../../services/entreprises/entrepriseRequest";
import CommandProccess from "./CommandProccess";
import fr from "date-fns/locale/fr";
import { rechercherrestaurantsautorises } from "../../services/statistiques/StatRequest";
import ModalCommandeEmploye from "../../commandes/ModalCommandeEmploye";

function Commandes() {
  registerLocale("fr", fr);
  const Onglets = {
    employes: "Employés",
    plats: "Plats",
    vendeuses: "Vendeuses",
    entreprise: "Entreprises",
  };

  let [viewPage, setViewPage] = useState("COMMANDES");
  let [loading, setLoading] = useState(false);
  let [startDate, setStartDate] = useState(new Date());
  let [endDate, setEndDate] = useState(new Date());
  let [ongletActif, setongletActif] = useState(Onglets.employes);
  let [vendeuseSelected, setvendeuseSelected] = useState(null);
  let [entrepriseSelected, setentrepriseSelected] = useState(null);
  let [siteEntrepriseSelected, setSiteEntrepriseSelected] = useState(null);
  let [listeRestaurant, setListeRestaurant] = useState(null);
  let [statutCommande, setStatutCommande] = useState(null);
  let [restaurantParentSelected, setRestaurantParentSelected] = useState(null);
  let [restaurantEnfantSelected, setRestaurantEnfantSelected] = useState("");
  let [restaurantSelected, setRestaurantSelected] = useState(null);
  let [modeRestaurationSelected, setModeRestaurationSelected] = useState(null);
  const [moisSelected, setmoisSelected] = useState(new Date().getMonth());
  let [jourSelected, setjourSelected] = useState(new Date());
  let [listecomandeentreprise, setListecommandeentreprise] = useState([]);
  let [listeRestaurants, setListeRestaurants] = useState([]);
  let [listeEntreprise, setListeEntreprise] = useState([]);
  let [listeSiteEntreprise, setListeSiteEntreprise] = useState([]);
  let [listeRestaurantParent, setListeRestaurantParent] = useState([]);

  let [entrepriseExport, setEntrepriseExport] = useState("");
  let [siteEntrepriseExport, setSiteEntrepriseExport] = useState("");
  let [restaurantExport, setRestaurantExport] = useState("");
  let [typeExport, setTypeExport] = useState("PLAT");
  let [typeProcessusExport, setTypeProcessusExport] = useState("TOUS");
  const [processDate, setProcessDate] = useState(new Date());

  let [alertDate, setAlertDate] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);

  const listeStatutCommande = [
    {
      id: 0,
      libelle: "En attente",
      valeur: "ATTENTE",
    },
    {
      id: 1,
      libelle: "Validé",
      valeur: "VALIDE",
    },
  ];

  const listeStatutCommandeProcess = [
    {
      id: 0,
      libelle: "En attente",
      valeur: "ATTENTE",
    },
    {
      id: 1,
      libelle: "Servit",
      valeur: "SERVIT",
    },
    {
      id: 2,
      libelle: "Validé",
      valeur: "VALIDE",
    },
    {
      id: 3,
      libelle: "Incomplet",
      valeur: "INCOMPLET",
    },
  ];

  const listeType = [
    {
      id: 0,
      libelle: "Par repas",
      value: "PLAT",
    },
    {
      id: 1,
      libelle: "Par commande",
      value: "COMMANDE",
    },
  ];

  const listeTypeProcessusCommandes = [
    {
      id: 0,
      libelle: "Tous",
      value: "TOUS",
    },
    {
      id: 1,
      libelle: "Hors délai",
      value: "HORS_DELAI",
    },
    {
      id: 1,
      libelle: "Dans le temps",
      value: "DANS_LE_TEMPS",
    },
  ];

  const changeOnglet = (value) => {
    ongletActif = value;
    setongletActif(ongletActif);
  };

  const handleVendeuses = (values) => {
    vendeuseSelected = values;
    setvendeuseSelected(vendeuseSelected);
  };

  const handleEntreprise = (values) => {
    entrepriseSelected = values;
    setentrepriseSelected(entrepriseSelected);
  };

  const handleSiteEntreprise = (values) => {
    siteEntrepriseSelected = values;
    setSiteEntrepriseSelected(siteEntrepriseSelected);
  };

  const handleModeRestauration = (values) => {
    modeRestaurationSelected = values;
    setModeRestaurationSelected(modeRestaurationSelected);
  };

  const handleListedesplat = (entreprise) => {
    setongletActif("Employés");
    setentrepriseSelected(entreprise);
  };

  const resultat =
    new Date().getMonth() <= moisSelected &&
    moment(jourSelected).format("yyyy-MM-DD");

  const rechercherentreprise = (resultat) => {
    rechercherentrepriseayantcommander(resultat, "").then((res) => {
      setListecommandeentreprise(res.data.donnee);
      setListeEntreprise(res.data.donnee);
    });
  };

  const afficherRestaurant = () => {
    rechercherRestaurantsAutorise(0, 1000)
      .then((response) => {
        const liste = response.data.donnee.restaurants;

        let restaurantAutorise = [];

        liste.map((element) => {
          if (DecodeToken().profil === "ROLE_COMPTABLE" && element.autorise === true) {
            restaurantAutorise.push(element);
          } else if (DecodeToken().profil === "ROLE_ADMIN" && element.enabled === true) {
            restaurantAutorise.push(element);
          }
        });

        setListeRestaurant(restaurantAutorise);
        setListeRestaurants(restaurantAutorise);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };

  const rechercherCommandeParModeRestauration = () => { };

  const handleChoixRestaurant = (value) => {
    setRestaurantSelected(value);
  };

  const handleChoixStatutCommande = (value) => {
    setStatutCommande(value);
  };

  const handleChoixRestaurantParent = (value) => {
    setRestaurantParentSelected(value);
  };

  const compareDate = (s, e) => {
    const start = new Date(s);
    const end = new Date(e);
    setStartDate(s);
    setEndDate(e);

    if (start.getTime() > end.getTime()) {
      setAlertDate("Choisir une date de fin supérieur à la date de début");
    } else if (start.getTime() < end.getTime()) {
      setAlertDate("");
    } else {
      setAlertDate("");
      console.log("Starting date is the same as ending date.");
    }
  };

  const formatDate = (dateTime) => {
    const day = dateTime.getDate().toString().padStart(2, "0");
    const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
    const year = dateTime.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };

  const rechercherSitesEntreprise = (entrepriseId) => {
    recherchersiteparentreprise(entrepriseId)
      .then((response) => {
        setListeSiteEntreprise(response.data.donnee);
      })
      .catch(() => {
        console.log("++++ error sites");
      });
  };

  const rechercherSitesEntrepriseConnecte = () => {
    rechercherSites()
      .then((response) => {
        setListeSiteEntreprise(response.data.donnee);
      })
      .catch(() => {
        console.log("++++ error sites");
      });
  };

  const exportDataCommande = () => {
    setLoading(true);

    exportDataCommandeFromApi(
      typeExport,
      restaurantExport
        ? restaurantExport
        : restaurantEnfantSelected
          ? restaurantEnfantSelected
          : 0,
      entrepriseExport ? entrepriseExport : 0,
      siteEntrepriseExport ? siteEntrepriseExport : 0,
      formatDate(startDate),
      formatDate(endDate)
    )
      .then((res) => {
        setLoading(false);
        setRestaurantExport("");
        setEntrepriseExport("");
        setStartDate(new Date());
        setEndDate(new Date());
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Commande.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.getElementById("closeBtn").click();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const exportDataProcessusCommande = () => {
    setLoading(true);
    // restaurantId,modeRecuperation,etat
    console.log(
      restaurantParentSelected,
      modeRestaurationSelected,
      statutCommande
    );
    const data = {
      etat: statutCommande ? statutCommande.valeur : null,
      modeRecuperation: modeRestaurationSelected
        ? modeRestaurationSelected.value
        : null,
      restaurantId: restaurantParentSelected
        ? restaurantParentSelected.id
        : null,
    };
    exportDataProcessusCommandesFromApi(
      formatDate(startDate),
      formatDate(endDate),
      typeProcessusExport,
      data
    )
      .then((res) => {
        setLoading(false);
        setRestaurantExport("");
        setEntrepriseExport("");
        setStartDate(new Date());
        setEndDate(new Date());
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `ProcessusCommandes.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.getElementById("closeBtn").click();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    rechercherentreprise(resultat);
  }, [resultat]);

  useEffect(() => {
    afficherRestaurant();
    if (DecodeToken().profil === "ROLE_ADMIN") {
      recherchertouslesRestaurants().then((response) => {
        setListeRestaurants(response.data.donnee);
        setListeRestaurantParent(response.data.donnee);
      });
    }

    if (DecodeToken().profil === "ROLE_RESTAURATRICE") {
      rechercherRestaurantsEnfant().then((response) => {
        setListeRestaurantParent(response.data.donnee);
      });
    }

    if (DecodeToken().profil === "ROLE_COMPTABLE") {
      rechercherSitesEntrepriseConnecte();
      rechercherrestaurantsautorises().then((response) => {
        setListeRestaurantParent(response.data.donnee);
      });
    }

    rechercherentreprises().then((response) => {
      setListeEntreprise(response.data.donnee);
    });
  }, []);

  return (
    <Layout>
      {DecodeToken().profil !== "ROLE_RESTAURATRICE" &&
        DecodeToken().profil !== "ROLE_ADMIN" &&
        DecodeToken().profil !== "ROLE_COMPTABLE" && (
          <Navigate to="/login" replace />
        )}
      <div>
        <HeaderNomResto />
        {/* MENU COMMANDES ET COMMANDES PROCESSUS */}
        {localStorage.getItem("process") === "true" ? (
          <div className="d-flex align-items-center gap-3">
            <h5
              className="mb-3 mt-3 fw-bold"
              style={
                viewPage === "COMMANDES"
                  ? { color: "#CE5D1D", cursor: "pointer" }
                  : { cursor: "pointer" }
              }
              onClick={() => setViewPage("COMMANDES")}
            >
              Commandes
            </h5>
            |
            <h5
              className="mb-3 mt-3 fw-bold"
              style={
                viewPage === "PROCESSUS"
                  ? { color: "#CE5D1D", cursor: "pointer" }
                  : { cursor: "pointer" }
              }
              onClick={() => setViewPage("PROCESSUS")}
            >
              Processus commandes
            </h5>
          </div>
        ) : (
          <h5
            className="mb-3 mt-3 fw-bold"
            style={
              viewPage === "COMMANDES"
                ? { color: "#CE5D1D", cursor: "pointer" }
                : { cursor: "pointer" }
            }
            onClick={() => setViewPage("COMMANDES")}
          >
            Commandes
          </h5>
        )}

        {viewPage === "COMMANDES" ? (
          <div className="bg-white rounded px-2 py-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <FilterDayAndMonth
                  setjourSelected={setjourSelected}
                  setmoisSelected={setmoisSelected}
                  rechercherentreprise={rechercherentreprise}
                />
              </div>
              {DecodeToken().profil !== "ROLE_RESTAURATRICE" && <button
                className="btn btn-sm btn-rose text-white"
                data-bs-target="#commandeEmploye"
                data-bs-toggle="modal"
              >
                COMMANDER
              </button>}
            </div>
            <div className="px-2 d-flex justify-content-between" style={{
              overflow: "auto"
            }}>
              <div className="d-flex">
                {/* Filtre sur employés */}
                <div
                  onClick={() => changeOnglet(Onglets.employes)}
                  className={
                    ongletActif !== Onglets.employes
                      ? "mb-3 p-2 cursor bg-filtre rounded mx-1"
                      : "mb-3 p-2 cursor btn-rose text-white rounded mx-1"
                  }
                >
                  <i className="fa fa-users"></i> Employés
                </div>
                {/* Fin filtre sur employés */}

                {/* Filtre sur plat */}
                <div
                  onClick={() => changeOnglet(Onglets.plats)}
                  className={
                    ongletActif === Onglets.plats
                      ? "mb-3 p-2 cursor btn-rose text-white rounded mx-1"
                      : "mb-3 p-2 cursor bg-filtre rounded mx-1"
                  }
                >
                  <span>
                    <svg
                      width="20"
                      height="14"
                      viewBox="0 0 20 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.5 9C0.367392 9 0.240215 9.05268 0.146447 9.14645C0.0526785 9.24021 0 9.36739 0 9.5C0 9.63261 0.0526785 9.75979 0.146447 9.85355C0.240215 9.94732 0.367392 10 0.5 10H2C2 11.0609 2.42143 12.0783 3.17157 12.8284C3.92172 13.5786 4.93914 14 6 14H14C15.0609 14 16.0783 13.5786 16.8284 12.8284C17.5786 12.0783 18 11.0609 18 10H19.5C19.6326 10 19.7598 9.94732 19.8536 9.85355C19.9473 9.75979 20 9.63261 20 9.5C20 9.36739 19.9473 9.24021 19.8536 9.14645C19.7598 9.05268 19.6326 9 19.5 9H0.5Z"
                        fill="#767676"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.55238 0.0264893L9.99988 0.249989L10.4474 0.473489L10.4464 0.474989L10.4404 0.487489L10.4154 0.542489C10.2818 0.8408 10.1812 1.15282 10.1154 1.47299C9.99738 2.06249 10.0409 2.58399 10.3534 2.89649C11.0409 3.58399 10.9974 4.56249 10.8654 5.22299C10.7793 5.64371 10.644 6.05285 10.4624 6.44199L10.4524 6.46349L10.4489 6.46999L10.4479 6.47249L10.4474 6.47299L9.99988 6.24999L9.55238 6.02649L9.55338 6.02499L9.55938 6.01249L9.58438 5.95749C9.71798 5.65918 9.81858 5.34716 9.88438 5.02699C10.0024 4.43749 9.95888 3.91599 9.64638 3.60349C8.95888 2.91599 9.00238 1.93749 9.13438 1.27699C9.22049 0.856269 9.35575 0.447128 9.53738 0.0579891L9.54738 0.036489L9.55088 0.0299892L9.55188 0.0279889L9.55238 0.026989V0.0264893ZM5.58488 1.22049L5.99988 1.50049C6.41438 1.77999 6.41488 1.77949 6.41488 1.77949V1.77899V1.77949L6.40838 1.78949C6.3645 1.85947 6.32347 1.93119 6.28538 2.00449C6.19085 2.18392 6.11544 2.37279 6.06038 2.56799C5.94038 3.01399 5.98338 3.36599 6.29738 3.59799C7.10838 4.19899 7.06538 5.09749 6.90438 5.69299C6.8308 5.95762 6.7294 6.21371 6.60188 6.45699C6.54613 6.56416 6.48557 6.66877 6.42038 6.77049L6.41638 6.77649L6.41538 6.77849L6.41488 6.77899C6.41488 6.77899 6.41438 6.77999 5.99988 6.49999C5.58538 6.21999 5.58488 6.22049 5.58488 6.22049L5.59138 6.21099L5.61838 6.16799C5.65203 6.11159 5.68405 6.05423 5.71438 5.99599C5.79188 5.84699 5.88088 5.64699 5.93938 5.43199C6.05938 4.98599 6.01638 4.63449 5.70238 4.40199C4.89138 3.80099 4.93438 2.90299 5.09538 2.30699C5.17788 2.00099 5.29988 1.73199 5.39788 1.54299C5.4537 1.43601 5.51426 1.33157 5.57938 1.22999L5.58288 1.22399L5.58438 1.22149L5.58538 1.22049H5.58488ZM14.0849 1.22049L14.4999 1.50049C14.9144 1.77999 14.9149 1.77949 14.9149 1.77949V1.77899V1.77949L14.9084 1.78949C14.8645 1.85947 14.8235 1.93119 14.7854 2.00449C14.6909 2.18392 14.6154 2.37279 14.5604 2.56799C14.4404 3.01399 14.4834 3.36599 14.7974 3.59799C15.6084 4.19899 15.5654 5.09749 15.4044 5.69299C15.3308 5.95762 15.2294 6.21371 15.1019 6.45699C15.0463 6.56415 14.9859 6.66876 14.9209 6.77049L14.9169 6.77649L14.9154 6.77849L14.9149 6.77899C14.9149 6.77899 14.9144 6.77999 14.4999 6.49999C14.0854 6.21999 14.0849 6.22049 14.0849 6.22049L14.0914 6.21099L14.1184 6.16799C14.152 6.11159 14.184 6.05423 14.2144 5.99599C14.2919 5.84699 14.3809 5.64699 14.4394 5.43199C14.5594 4.98599 14.5164 4.63449 14.2024 4.40199C13.3914 3.80099 13.4344 2.90299 13.5954 2.30699C13.6779 2.00099 13.7999 1.73199 13.8979 1.54299C13.9535 1.43602 14.0139 1.33158 14.0789 1.22999L14.0829 1.22399L14.0844 1.22149L14.0854 1.22049H14.0849Z"
                        fill="#767676"
                      />
                    </svg>
                  </span>{" "}
                  Plats
                </div>
                {/* Fin filtre sur plat */}

                {/* Export commande */}
                <div
                  className="mb-3 p-2 cursor btn-success text-white rounded mx-1"
                  data-bs-target="#exportCommande"
                  data-bs-toggle="modal"
                >
                  <i className="fa fa-file"></i> Export
                </div>

                {/* Filtre par entreprise  */}
                {DecodeToken().profil === "ROLE_RESTAURATRICE" && (
                  <div
                    onClick={() => changeOnglet(Onglets.entreprise)}
                    className={
                      ongletActif === Onglets.entreprise
                        ? "mb-3 p-2 cursor btn-rose text-white rounded mx-1 filtreentreprise"
                        : "mb-3 p-2 cursor bg-filtre rounded mx-1 filtreentreprise"
                    }
                  >
                    <span>
                      <i className="bi bi-building"></i>
                    </span>{" "}
                    Entreprises
                  </div>
                )}
                {/* Fin du filtre par entreprise */}
              </div>

              {DecodeToken().profil === "ROLE_ADMIN" && (
                <div className="d-flex">
                  <div className="mx-1">
                    <ListeVendeuse
                      width={150}
                      setdataSelected={handleVendeuses}
                    />
                  </div>
                  <div className="mx-1">
                    <ModeRestauration
                      width={150}
                      setModeRestaurationSelected={handleModeRestauration}
                      modeRestaurationSelected={modeRestaurationSelected}
                      rechercherCommandeParModeRestauration={
                        rechercherCommandeParModeRestauration
                      }
                    />
                  </div>
                  <div>
                    <ListeEntreprise
                      width={150}
                      setdataSelected={handleEntreprise}
                      setdataSiteSelected={handleSiteEntreprise}
                    />
                  </div>
                  <div className="mx-1">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={listeStatutCommande}
                      getOptionLabel={(option) => option.libelle ?? option}
                      value={statutCommande}
                      onChange={(event, value) =>
                        handleChoixStatutCommande(value)
                      }
                      sx={{ width: 150 }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="bg-white"
                          label="Statut"
                        />
                      )}
                    />
                  </div>
                </div>
              )}

              {DecodeToken().profil === "ROLE_COMPTABLE" && (
                <div className="d-flex gap-2">
                  <ModeRestauration
                    width={200}
                    setModeRestaurationSelected={handleModeRestauration}
                    modeRestaurationSelected={modeRestaurationSelected}
                    rechercherCommandeParModeRestauration={
                      rechercherCommandeParModeRestauration
                    }
                  />
                  <div>
                    <ListeEntreprise
                      width={150}
                      setdataSelected={handleEntreprise}
                      setdataSiteSelected={handleSiteEntreprise}
                    />
                  </div>
                  <div className="mx-1">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={listeRestaurant}
                      getOptionLabel={(option) => option.nom ?? option}
                      value={restaurantSelected}
                      onChange={(event, value) => handleChoixRestaurant(value)}
                      sx={{ width: 180 }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="bg-white"
                          label="Restaurant"
                        />
                      )}
                    />
                  </div>
                  <div className="mx-1">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={listeStatutCommande}
                      getOptionLabel={(option) => option.libelle ?? option}
                      value={statutCommande}
                      onChange={(event, value) =>
                        handleChoixStatutCommande(value)
                      }
                      sx={{ width: 180 }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="bg-white"
                          label="Statut"
                        />
                      )}
                    />
                  </div>
                </div>
              )}

              {DecodeToken().profil === "ROLE_RESTAURATRICE" && (
                <div>
                  <div className="d-flex gap-2">
                    <ModeRestauration
                      width={180}
                      setModeRestaurationSelected={handleModeRestauration}
                      modeRestaurationSelected={modeRestaurationSelected}
                      rechercherCommandeParModeRestauration={
                        rechercherCommandeParModeRestauration
                      }
                    />

                    <ListeEntreprise
                      width={180}
                      setdataSelected={handleEntreprise}
                      setdataSiteSelected={handleSiteEntreprise}
                      jourSelected={jourSelected}
                      listecomandeentreprise={listecomandeentreprise}
                      rechercherentreprise={rechercherentreprise}
                      entrepriseSelected={entrepriseSelected}
                      siteEntrepriseSelected={siteEntrepriseSelected}
                    />

                    <div className="mx-1">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={listeStatutCommande}
                        getOptionLabel={(option) => option.libelle ?? option}
                        value={statutCommande}
                        onChange={(event, value) =>
                          handleChoixStatutCommande(value)
                        }
                        sx={{ width: 150 }}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="bg-white"
                            label="Statut"
                          />
                        )}
                      />
                    </div>

                    <div className="mx-1">
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={listeRestaurantParent}
                        getOptionLabel={(option) => option.nom ?? option}
                        value={restaurantParentSelected}
                        onChange={(event, value) =>
                          handleChoixRestaurantParent(value)
                        }
                        sx={{ width: 150 }}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="bg-white"
                            label="Restaurant"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {ongletActif === Onglets.employes && (
              <CommandEmployes
                vendeuse={vendeuseSelected}
                restaurant={restaurantSelected}
                restaurantParent={restaurantParentSelected}
                statut={statutCommande}
                modeRecuperation={modeRestaurationSelected}
                entreprise={entrepriseSelected}
                siteEntreprise={siteEntrepriseSelected}
                jourSelected={jourSelected}
                refreshKey={refreshKey}
              />
            )}

            {ongletActif === Onglets.plats && (
              <CommandPlats
                vendeuse={vendeuseSelected}
                entreprise={entrepriseSelected}
                siteEntreprise={siteEntrepriseSelected}
                restaurant={restaurantSelected}
                restaurantParent={restaurantParentSelected}
                statut={statutCommande}
                modeRecuperation={modeRestaurationSelected}
                jourSelected={jourSelected}
                refreshKey={refreshKey}
              />
            )}

            {DecodeToken().profil === "ROLE_RESTAURATRICE" &&
              ongletActif === Onglets.entreprise && (
                <CommandEntreprises
                  moisSelected={moisSelected}
                  modeRecuperation={modeRestaurationSelected}
                  jourSelected={jourSelected}
                  handleListedesplat={handleListedesplat}
                />
              )}
          </div>
        ) : null}

        {viewPage === "PROCESSUS" ? (
          <div className="bg-white rounded px-2 py-3">
            <div className="px-2 d-flex align-items-center justify-content-start gap-2 mb-2">
              <div style={{ width: "110px", borderRadius: 10 }}>
                <DatePicker
                  locale="fr"
                  dateFormat="dd/MM/yyyy"
                  selected={processDate}
                  onChange={(date) => setProcessDate(date)}
                  style={{ borderRadius: 10 }}
                />
              </div>
              <div>
                <ModeRestauration
                  width={180}
                  setModeRestaurationSelected={handleModeRestauration}
                  modeRestaurationSelected={modeRestaurationSelected}
                  rechercherCommandeParModeRestauration={
                    rechercherCommandeParModeRestauration
                  }
                />
              </div>
              <div>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={listeStatutCommandeProcess}
                  getOptionLabel={(option) => option.libelle ?? option}
                  value={statutCommande}
                  onChange={(event, value) => handleChoixStatutCommande(value)}
                  sx={{ width: 150 }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="bg-white"
                      label="Statut"
                    />
                  )}
                />
              </div>
              <div>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={listeRestaurantParent}
                  getOptionLabel={(option) => option.nom ?? option}
                  value={restaurantParentSelected}
                  onChange={(event, value) =>
                    handleChoixRestaurantParent(value)
                  }
                  sx={{ width: 150 }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className="bg-white"
                      label="Restaurant"
                    />
                  )}
                />
              </div>

              {/* Export Processus commande */}
              <div
                className="mb-0 p-2 cursor btn-success text-white rounded mx-1"
                data-bs-target="#exportProcessusCommande"
                data-bs-toggle="modal"
              >
                <i className="fa fa-file"></i> Export
              </div>
            </div>
            <CommandProccess
              restaurantParent={restaurantParentSelected}
              statut={statutCommande}
              modeRecuperation={modeRestaurationSelected}
              jourSelected={processDate}
            />
          </div>
        ) : null}
      </div>

      {/* MODAL COMMANDE POUR EMPLOYE D'UNE ENTREPRISE */}
      <div
        class="modal fade"
        id="commandeEmploye"
        tabindex="-1"
        aria-labelledby="commandeEmployeLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen-xl-down modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold text-rose mb-2" id="commandeEmployeLabel">
                Commander pour les employés de l'entreprise
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <ModalCommandeEmploye
                listeRestaurant={listeRestaurant}
                onCommandeSuccess={() => {
                  rechercherentreprise(resultat);
                  setRefreshKey(prev => prev + 1);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/** Affichage modal export commande */}
      <div
        className="modal fade"
        id="exportCommande"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          style={{ width: "35%" }}
        >
          <div className="modal-content bg-rose">
            <div className="p-2 d-flex justify-content-end">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeBtn"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-5">
                <h6 className="text-center" style={{ fontSize: 21 }}>
                  Export des commandes
                </h6>
              </div>

              <div className="mt-2">
                <div className="d-flex align-items-center gap-4">
                  <div className="w-50">
                    <p style={{ padding: 0, margin: 0 }}>Date début</p>
                    <DatePicker
                      onChange={(date) => compareDate(date, endDate)}
                      selected={startDate}
                      dateFormat="dd/MM/yyyy"
                      className="w-full"
                    />
                  </div>
                  <div className="w-50">
                    <p style={{ padding: 0, margin: 0 }}>Date fin</p>
                    <DatePicker
                      onChange={(date) => compareDate(startDate, date)}
                      selected={endDate}
                      dateFormat="dd/MM/yyyy"
                      className="w-full"
                    />
                  </div>
                </div>
                {alertDate ? (
                  <p className="text-danger text-center fw-bold">{alertDate}</p>
                ) : null}
                <div className="mt-3">
                  <select
                    value={typeExport}
                    onChange={(e) => setTypeExport(e.target.value)}
                    className="form-select w-full font-normal"
                  >
                    <option value="" disabled selected>
                      Choisir un type
                    </option>
                    {listeType.map((item) => (
                      <option value={item.value} key={item.id}>
                        {item.libelle}
                      </option>
                    ))}
                  </select>
                </div>
                {DecodeToken().profil === "ROLE_RESTAURATRICE" ||
                  DecodeToken().profil === "ROLE_ADMIN" ? (
                  <div>
                    <div className="mt-3">
                      <select
                        value={entrepriseExport}
                        onChange={(e) => {
                          setEntrepriseExport(e.target.value);
                          rechercherSitesEntreprise(e.target.value)
                        }}
                        className="form-select w-full font-normal"
                      >
                        <option value="" disabled selected>
                          Choisir une entreprise
                        </option>
                        <option value="">Tous</option>
                        {listeEntreprise.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.raisonSociale}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mt-3">
                      <select
                        value={siteEntrepriseExport}
                        onChange={(e) => setSiteEntrepriseExport(e.target.value)}
                        className="form-select w-full font-normal"
                      >
                        <option value="" disabled selected>
                          Choisir un site entreprise
                        </option>
                        <option value="">Tous</option>
                        {listeSiteEntreprise.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.nom}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : null}
                {DecodeToken().profil === "ROLE_COMPTABLE" && <div className="mt-3">
                  <select
                    value={siteEntrepriseExport}
                    onChange={(e) => setSiteEntrepriseExport(e.target.value)}
                    className="form-select w-full font-normal"
                  >
                    <option value="" disabled selected>
                      Choisir un site entreprise
                    </option>
                    <option value="">Tous</option>
                    {listeSiteEntreprise.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.nom}
                      </option>
                    ))}
                  </select>
                </div>}
                {DecodeToken().profil === "ROLE_COMPTABLE" ||
                  DecodeToken().profil === "ROLE_ADMIN" ? (
                  <div className="mt-3">
                    <select
                      value={restaurantExport}
                      onChange={(e) => setRestaurantExport(e.target.value)}
                      className="form-select w-full font-normal"
                    >
                      <option value="" disabled selected>
                        Choisir une restauratrice
                      </option>
                      <option value="">Tous</option>
                      {listeRestaurants.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
                {DecodeToken().profil === "ROLE_RESTAURATRICE" ? (
                  <div className="mt-3">
                    <select
                      value={restaurantEnfantSelected}
                      onChange={(e) =>
                        setRestaurantEnfantSelected(e.target.value)
                      }
                      className="form-select w-full font-normal"
                    >
                      <option value="" disabled selected>
                        Choisir une restaurant enfant
                      </option>
                      <option value="">Tous</option>
                      {listeRestaurantParent.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
              </div>

              <div className="mb-3 row mx-2 my-3">
                <Oval
                  width={40}
                  height={40}
                  color="#CE5D1D"
                  visible={loading}
                />
                {!loading && (
                  <button
                    disabled={alertDate}
                    type="submit"
                    className="btn text-white btn-rose"
                    onClick={exportDataCommande}
                  >
                    Exporter
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/** Affichage modal export processus commandes */}
      <div
        className="modal fade"
        id="exportProcessusCommande"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          style={{ width: "35%" }}
        >
          <div className="modal-content bg-rose">
            <div className="p-2 d-flex justify-content-end">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeBtn"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-5">
                <h6 className="text-center" style={{ fontSize: 21 }}>
                  Export processus des commandes
                </h6>
              </div>

              <div className="mt-2">
                <div className="d-flex align-items-center gap-4">
                  <div className="w-50">
                    <p style={{ padding: 0, margin: 0 }}>Date début</p>
                    <DatePicker
                      onChange={(date) => compareDate(date, endDate)}
                      selected={startDate}
                      dateFormat="dd/MM/yyyy"
                      className="w-full"
                    />
                  </div>
                  <div className="w-50">
                    <p style={{ padding: 0, margin: 0 }}>Date fin</p>
                    <DatePicker
                      onChange={(date) => compareDate(startDate, date)}
                      selected={endDate}
                      dateFormat="dd/MM/yyyy"
                      className="w-full"
                    />
                  </div>
                </div>
                {alertDate ? (
                  <p className="text-danger text-center fw-bold">{alertDate}</p>
                ) : null}
                <div className="mt-3">
                  <select
                    value={typeProcessusExport}
                    onChange={(e) => setTypeProcessusExport(e.target.value)}
                    className="form-select w-full font-normal"
                  >
                    <option value="" disabled selected>
                      Choisir un type
                    </option>
                    {listeTypeProcessusCommandes.map((item) => (
                      <option value={item.value} key={item.id}>
                        {item.libelle}
                      </option>
                    ))}
                  </select>
                </div>
                {/* {DecodeToken().profil === "ROLE_RESTAURATRICE" ||
                DecodeToken().profil === "ROLE_ADMIN" ? (
                  <div className="mt-3">
                    <select
                      value={entrepriseExport}
                      onChange={(e) => setEntrepriseExport(e.target.value)}
                      className="form-select w-full font-normal"
                    >
                      <option value="" disabled selected>
                        Choisir une entreprise
                      </option>
                      <option value="">Tous</option>
                      {listeEntreprise.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.raisonSociale}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
                {DecodeToken().profil === "ROLE_COMPTABLE" ||
                DecodeToken().profil === "ROLE_ADMIN" ? (
                  <div className="mt-3">
                    <select
                      value={restaurantExport}
                      onChange={(e) => setRestaurantExport(e.target.value)}
                      className="form-select w-full font-normal"
                    >
                      <option value="" disabled selected>
                        Choisir une restauratrice
                      </option>
                      <option value="">Tous</option>
                      {listeRestaurants.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null}
                {DecodeToken().profil === "ROLE_RESTAURATRICE" ? (
                  <div className="mt-3">
                    <select
                      value={restaurantEnfantSelected}
                      onChange={(e) =>
                        setRestaurantEnfantSelected(e.target.value)
                      }
                      className="form-select w-full font-normal"
                    >
                      <option value="" disabled selected>
                        Choisir une restaurant enfant
                      </option>
                      <option value="">Tous</option>
                      {listeRestaurantParent.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                ) : null} */}
              </div>

              <div className="mb-3 row mx-2 my-3">
                <Oval
                  width={40}
                  height={40}
                  color="#CE5D1D"
                  visible={loading}
                />
                {!loading && (
                  <button
                    disabled={alertDate}
                    type="submit"
                    className="btn text-white btn-rose"
                    onClick={exportDataProcessusCommande}
                  >
                    Exporter
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Commandes;
